module.exports = __webpack_public_path__ + "static/media/Trash.7b8bd970.svg";